module.exports = __webpack_public_path__ + "static/media/cntrl_play.560c198b.svg";